'use client';
import { Box } from '@skin-seoul/design-system';

import { LoyaltyPointsSignUpBannerDesktop } from './LoyaltyPointsSignUpBanner.Desktop';
import { LoyaltyPointsSignUpBannerMobile } from './LoyaltyPointsSignUpBanner.Mobile';

export const LoyaltyPointsSignUpBanner = () => {
  return (
    <>
      {/* Mobile View - Below tablet breakpoint (768px) */}
      <Box width="100%" hideFrom="tablet">
        <LoyaltyPointsSignUpBannerMobile />
      </Box>

      {/* Desktop View - Above tablet breakpoint */}
      <Box width="100%" hideBelow="tablet">
        <LoyaltyPointsSignUpBannerDesktop />
      </Box>
    </>
  );
};
